// UI5 Web Components used
import { setTheme } from '@ui5/webcomponents-base/dist/config/Theme';
setTheme('sap_horizon');

import '@ui5/webcomponents-base/dist/features/F6Navigation';
import '@ui5/webcomponents/dist/Badge';
import '@ui5/webcomponents/dist/Button';
import '@ui5/webcomponents/dist/Card';
import '@ui5/webcomponents/dist/CardHeader.js';
import '@ui5/webcomponents/dist/ComboBox.js';
import '@ui5/webcomponents/dist/CustomListItem';
import '@ui5/webcomponents/dist/DatePicker';
import '@ui5/webcomponents/dist/Dialog';
import '@ui5/webcomponents/dist/Input';
import '@ui5/webcomponents/dist/Label';
import '@ui5/webcomponents/dist/List';
import '@ui5/webcomponents/dist/Option';
import '@ui5/webcomponents/dist/Panel';
import '@ui5/webcomponents/dist/Popover';
import '@ui5/webcomponents/dist/Select';
import '@ui5/webcomponents/dist/StandardListItem';
import '@ui5/webcomponents/dist/Switch';
import '@ui5/webcomponents/dist/Tab';
import '@ui5/webcomponents/dist/TabContainer';
import '@ui5/webcomponents/dist/Table.js';
import '@ui5/webcomponents/dist/TableCell.js';
import '@ui5/webcomponents/dist/TableColumn.js';
import '@ui5/webcomponents/dist/TableRow.js';
import '@ui5/webcomponents/dist/TextArea';
import '@ui5/webcomponents/dist/Title';
import '@ui5/webcomponents/dist/Toast.js';

import '@ui5/webcomponents-fiori/dist/SideNavigation.js';
import '@ui5/webcomponents-fiori/dist/SideNavigationItem.js';
import '@ui5/webcomponents-fiori/dist/SideNavigationSubItem.js';

import '@ui5/webcomponents-fiori/dist/Assets';
import '@ui5/webcomponents-fiori/dist/ShellBar';
import '@ui5/webcomponents-fiori/dist/ShellBarItem';
import '@ui5/webcomponents-fiori/dist/Timeline';

import '@ui5/webcomponents-icons/dist/accept.js';
import '@ui5/webcomponents-icons/dist/account.js';
import '@ui5/webcomponents-icons/dist/addresses.js';
import '@ui5/webcomponents-icons/dist/begin.js';
import '@ui5/webcomponents-icons/dist/business-card.js';
import '@ui5/webcomponents-icons/dist/calendar.js';
import '@ui5/webcomponents-icons/dist/comment.js';
import '@ui5/webcomponents-icons/dist/company-view.js';
import '@ui5/webcomponents-icons/dist/date-time.js';
import '@ui5/webcomponents-icons/dist/decline.js';
import '@ui5/webcomponents-icons/dist/delete.js';
import '@ui5/webcomponents-icons/dist/employee-rejections.js';
import '@ui5/webcomponents-icons/dist/globe.js';
import '@ui5/webcomponents-icons/dist/key.js';
import '@ui5/webcomponents-icons/dist/loan.js';
import '@ui5/webcomponents-icons/dist/locked.js';
import '@ui5/webcomponents-icons/dist/log.js';
import '@ui5/webcomponents-icons/dist/menu.js';
import '@ui5/webcomponents-icons/dist/message-information.js';
import '@ui5/webcomponents-icons/dist/navigation-down-arrow.js';
import '@ui5/webcomponents-icons/dist/navigation-left-arrow.js';
import '@ui5/webcomponents-icons/dist/newspaper.js';
import '@ui5/webcomponents-icons/dist/org-chart.js';
import '@ui5/webcomponents-icons/dist/palette.js';
import '@ui5/webcomponents-icons/dist/pending.js';
import '@ui5/webcomponents-icons/dist/private.js';
import '@ui5/webcomponents-icons/dist/settings.js';
import '@ui5/webcomponents-icons/dist/stop.js';
import '@ui5/webcomponents-icons/dist/sys-help.js';
import '@ui5/webcomponents-icons/dist/unlocked.js';
import '@ui5/webcomponents-icons/dist/wrench.js';
import '@ui5/webcomponents-icons/dist/cancel.js';
import '@ui5/webcomponents-icons/dist/sort-ascending.js';
import '@ui5/webcomponents-icons/dist/sort-descending';
import '@ui5/webcomponents-icons/dist/sort.js';
import '@ui5/webcomponents-icons/dist/arobase.js';
import '@ui5/webcomponents-icons/dist/home.js';